import { ReactNode } from "react";
import { Text } from "@merge-api/merge-javascript-shared";
import { ChevronDown } from "lucide-react";

// Shared form primitives for the conductor editor drawers, matching the
// design's labelled sections and inputs.

export const Section = ({ title, children }: { title: string; children: ReactNode }) => (
  <div className="border-b border-gray-10 py-4 first:pt-0 last:border-b-0">
    <Text variant="sm" className="mb-3 block font-semibold uppercase tracking-wide text-gray-50">
      {title}
    </Text>
    {children}
  </div>
);

export const FieldLabel = ({ children }: { children: ReactNode }) => (
  <Text variant="sm" className="mb-1 block text-gray-60">
    {children}
  </Text>
);

export const Select = ({
  value,
  onChange,
  children,
  disabled = false,
}: {
  value: string;
  onChange: (value: string) => void;
  children: ReactNode;
  disabled?: boolean;
}) => (
  <div className="relative">
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      style={{ appearance: "none", WebkitAppearance: "none", MozAppearance: "none" }}
      className="w-full appearance-none rounded-md border border-gray-20 bg-white py-2 pl-2.5 pr-8 font-mono text-sm text-gray-90 disabled:opacity-50"
    >
      {children}
    </select>
    <span className="pointer-events-none absolute inset-y-0 right-2.5 flex items-center text-gray-50">
      <ChevronDown size={16} />
    </span>
  </div>
);
